import React, { ReactNode } from 'react'

type Props = {
  className?: string
  children?: ReactNode
  onClick?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void
  to: string
}

export default function OuterLink({ className, children, onClick, to }: Props) {
  return (
    <a className={className} href={to} onClick={onClick} rel="noopener noreferrer" target="_blank">
      {children}
    </a>
  )
}
